import {
  Box,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select as MuiSelect,
  TextField as MuiTextField,
  Typography,
} from "@mui/material";
import Stack from '@mui/material/Stack';
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { spacing } from "@mui/system";
import axios from "axios";
import { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Autocomplete from '@mui/material/Autocomplete';

const Select = styled(MuiSelect)(spacing);
const TextField = styled(MuiTextField)(spacing);

const getPropertyNameToUuid = (properties, uuid) => {
  let ind = properties.findIndex((elem) => elem.uuid == uuid);
  return properties[ind].name;
};

const getPropertyIdToUuid = (properties, uuid) => {
  let ind = properties.findIndex((elem) => elem.uuid == uuid);
  return properties[ind].id;
};

export default (props) => {
  const actionProp = props.action;
  const handleClose = props.handleClose;
  const properties = props.properties.data.propertiesList.items;

  const [units, setUnits] = useState([]);
  const [unit, setUnit] = useState([]);
  const [unitInfo, setUnitInfo] = useState({
    uuid: "",
    bedrooms: null,
    baths: null,
  });
  const [areUnitsLoading, setAreUnitsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [currentOccupant, setCurrentOccupant] = useState();
  const [unitAutoComplete, setUnitsAutoComplete] = useState([]);


  // used as the base for validation
  const [newMoveObjTemp, setNewMoveObjTemp] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone1: "",
    address1: "",
    city: "",
    state: "",
    zip: "",
    billingAddress1: "",
    billingCity: "",
    billingState: "",
    billingZip: "",
    propertyUuid: "",
    unitUuid: "",
    moveInDate: "",
    ssn: "",
    eBills: 0,
    printedBills: 0,
    userAccountExists: 0,
  });

  const [state, setState] = React.useState({
    billingSame: false,
  });

  const [readTypeChecked, setReadTypeChecked] = useState("");
  const [useServiceAddress, setUseServiceAddress] = React.useState(true);

  const handleReadTypeChange = (type) => {
    if (readTypeChecked == type) setReadTypeChecked("");
    else setReadTypeChecked(type);
  };

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const handleUseServiceAddressChange = (event) => {
    if (useServiceAddress) {
      setUseServiceAddress(false);
    }
    else {
      setUseServiceAddress(true);
    }
  };

  const onFieldChange = async (e) => {
    console.log(e);
    if (e) {
      setNewMoveObjTemp({ ...newMoveObjTemp, [e.target.name]: e.target.value });
      if (e.target.name == "unitUuid") {
        try {
          let response = await axios.get(`unit-current-occupant/${e.target.value}`)
          setCurrentOccupant(response.data[0])
        } catch (e) {
          console.log(e);
        }

      }

    }
    // validation stuff
    if (submitted) setSubmitted(false);
  };

  const onUnitFieldsChange = (e) => {
    let { name, value } = e.target;
    if (Number(value) < 0) {
      value = '';
    }

    if (name && value && unit?.uuid) {
      setUnitInfo({
        ...unitInfo,
        uuid: unit.uuid,
        [name]: value,
      })
    }
  };



  const onCheckboxChange = (e) => {
    setNewMoveObjTemp({
      ...newMoveObjTemp,
      [e.target.name]: e.target.checked == true ? 1 : 0,
    });
  };

  function checkEmpty(value) {
    return value != null && value != "" && value != 0;
  }

  const validate = () => {
    let possibleBillingAddress = {};
    if (!useServiceAddress) {
      possibleBillingAddress = state.billingSame
        ? Object.assign(
          {},
          {
            billingAddress1: newMoveObjTemp.address1,
            billingAddress2: newMoveObjTemp.address2,
            billingState: newMoveObjTemp.state,
            billingCity: newMoveObjTemp.city,
            billingZip: newMoveObjTemp.zip,
          }
        )
        : {};
    }
    else {
      let selectedUnitIndex = units.findIndex(object => {
        return object.uuid === newMoveObjTemp.unitUuid;
      });
      if (selectedUnitIndex != -1) {
        console.log("possibleBillingAddress = service address");
        possibleBillingAddress =
        {
          address1: units[selectedUnitIndex].address1,
          address2: units[selectedUnitIndex].address2 || "",
          city: units[selectedUnitIndex].city,
          state: units[selectedUnitIndex].state,
          zip: units[selectedUnitIndex].zip,
          billingAddress1: units[selectedUnitIndex].address1,
          billingAddress2: units[selectedUnitIndex].address2 || '',
          billingState: units[selectedUnitIndex].state,
          billingCity: units[selectedUnitIndex].city,
          billingZip: units[selectedUnitIndex].zip,
        }
      }

    }


    console.log("possibleBillingAddress: ", possibleBillingAddress);

    let newMoveInObjState = Object.assign(
      {},
      newMoveObjTemp,
      possibleBillingAddress
    );
    var moveInObjToValidate = Object.assign(
      {},
      newMoveInObjState
    );
    // remove unnecessary fields from being checked
    if (moveInObjToValidate["meterRead"]) delete moveInObjToValidate["meterRead"];
    if ("address2" in moveInObjToValidate) {

      delete moveInObjToValidate["address2"];

    }
    delete moveInObjToValidate["billingAddress2"];
    delete moveInObjToValidate["eBills"];
    delete moveInObjToValidate["printedBills"];
    delete moveInObjToValidate["userAccountExists"];
    const values = [];

    Object.keys(moveInObjToValidate).forEach(function (key) {
      let val = moveInObjToValidate[key];
      console.log(`Key is:  ${key}. Val is: ${val}`);
      values.push(val);
    });

    if (values.every(checkEmpty)) {
      console.log("validate success");
      return newMoveInObjState;
    } else {
      console.log("validation fail");
      console.log("newMoveObjTemp firstName is: ", newMoveInObjState["firstName"]);
      return -1;
    }
  };

  const action = (moveInObj, isBillingSame, unitInfo) => {
    console.log(unitInfo, 'unitInfo')
    const newMoveIn = validate();

    if (newMoveIn == -1) {
      console.log("setting submitted to true");
      setSubmitted(true);
      return;
    }

    actionProp(newMoveIn, isBillingSame, unitInfo);
    handleClose();
  };

  const handlePropertyChange = (uuid, event) => {
    // reset units and info
    setUnit(null)
    setUnitInfo({
      uuid: "",
      bedrooms: null,
      baths: null,
    });

    if (properties && properties.length) {
      onFieldChange(event);
      const propertyId = getPropertyIdToUuid(properties, uuid);
      setAreUnitsLoading(true);

      axios
        .get(`/unit/property/${propertyId}`)
        .then((res) => {

          const units = {
            options: res.data,
            getOptionLabel: (option => `${option.address1} ${option.address2 || ""}`)
          }
          setUnits(res.data);
          setUnitsAutoComplete(units)


          setAreUnitsLoading(false);
        })
        .catch(console.log);
    }
  };

  const fetchInitialUnits = () => {
    if (!isEmpty(newMoveObjTemp) && newMoveObjTemp.propertyUuid)
      handlePropertyChange(newMoveObjTemp.propertyUuid);
  };

  useEffect(() => {
    fetchInitialUnits();
  }, []);



  const sectionSx = { p: 2, borderRadius: 2 };
  const titleSx = { mb: 1.5, fontWeight: 600, color: "text.secondary" };

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
      {/* Contact Info */}
      <Paper elevation={2} sx={sectionSx}>
        <Typography variant="subtitle1" sx={titleSx}>Contact Info</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                {/* Row 1: First Name, Last Name */}
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, '& > *': { flex: '1 1 180px', minWidth: 0 } }}>
                  <TextField
                    label="First Name"
                    type="text"
                    onChange={onFieldChange}
                    name="firstName"
                    defaultValue={newMoveObjTemp.firstName}
                    fullWidth
                    size="small"
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      }
                    }}
                    error={newMoveObjTemp["firstName"] == "" && submitted}
                    helperText={
                      newMoveObjTemp["firstName"] == ""
                        ? "First name required."
                        : "" && submitted
                    }
                  />
                  <TextField
                    label="Last Name"
                    type="text"
                    onChange={onFieldChange}
                    name="lastName"
                    defaultValue={newMoveObjTemp.lastName}
                    fullWidth
                    size="small"
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      }
                    }}
                    error={newMoveObjTemp["lastName"] == "" && submitted}
                    helperText={
                      newMoveObjTemp["lastName"] == ""
                        ? "Last name required."
                        : "" && submitted
                    }
                  />
                </Box>
                {/* Row 2: SSN, Email */}
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, '& > *': { flex: '1 1 180px', minWidth: 0 } }}>
                  <TextField
                    label="SSN or EIN"
                    type="password"
                    onChange={onFieldChange}
                    name="ssn"
                    defaultValue={newMoveObjTemp.ssn}
                    fullWidth
                    size="small"
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      }
                    }}
                    error={
                      (newMoveObjTemp["ssn"] == 0 ||
                        newMoveObjTemp["ssn"] == "") &&
                      submitted
                    }
                    helperText={
                      newMoveObjTemp["ssn"] == 0 || newMoveObjTemp["ssn"] == ""
                        ? "SSN required."
                        : "" && submitted
                    }
                  />
                  <TextField
                    label="Email"
                    type="text"
                    onChange={onFieldChange}
                    name="email"
                    defaultValue={newMoveObjTemp.email}
                    fullWidth
                    size="small"
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      }
                    }}
                    error={newMoveObjTemp["email"] == "" && submitted}
                    helperText={
                      newMoveObjTemp["email"] == ""
                        ? "Email required."
                        : "" && submitted
                    }
                  />
                </Box>
                {/* Row 3: Phone 1, Phone 2 */}
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, '& > *': { flex: '1 1 180px', minWidth: 0 } }}>
                  <TextField
                    label="Phone 1"
                    type="text"
                    onChange={onFieldChange}
                    name="phone1"
                    defaultValue={newMoveObjTemp.phone1}
                    fullWidth
                    size="small"
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      }
                    }}
                    error={newMoveObjTemp["phone1"] == "" && submitted}
                    helperText={
                      newMoveObjTemp["phone1"] == ""
                        ? "Phone required."
                        : "" && submitted
                    }
                  />
                  <TextField
                    label="Phone 2"
                    type="text"
                    onChange={onFieldChange}
                    name="phone2"
                    defaultValue={newMoveObjTemp.phone2}
                    fullWidth
                    size="small"
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      }
                    }}
                  />
                </Box>
                {/* Row 4: Checkboxes */}
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={newMoveObjTemp.eBills ? true : false}
                        onChange={onCheckboxChange}
                        name="eBills"
                        value="E-Bills"
                      />
                    }
                    label="E-Bills"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={newMoveObjTemp.printedBills ? true : false}
                        onChange={onCheckboxChange}
                        name="printedBills"
                        value="Print Bills"
                      />
                    }
                    label="Print Bills"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={newMoveObjTemp.userAccountExists ? true : false}
                        onChange={onCheckboxChange}
                        name="userAccountExists"
                        value="User Exists"
                      />
                    }
                    label="User Exists"
                  />
                </Box>
        </Box>
      </Paper>

      {/* Unit Info */}
      <Paper elevation={2} sx={sectionSx}>
        <Typography variant="subtitle1" sx={titleSx}>Unit Info</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="property">Property</InputLabel>
                      <Select
                        labelId="property"
                        label="Property"
                        id="propertyUuid"
                        value={newMoveObjTemp.propertyUuid || "none"}
                        onChange={(e) => handlePropertyChange(e.target.value, e)}
                        name="propertyUuid"
                        error={newMoveObjTemp["propertyUuid"] == "" && submitted}
                        slotProps={{
                          inputLabel: {
                            shrink: true,
                          }
                        }}
                      >[
                        <MenuItem value={"none"}>None</MenuItem>
                        {properties.map((item, index) => (
                          <MenuItem value={item.uuid} key={index}>
                            {item.name}
                          </MenuItem>
                        ))}
                        ]
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth size="small">
                      {(units && units.length > 0) ?
                        <Autocomplete
                          {...unitAutoComplete}
                          disablePortal
                          size="small"
                          name="unitUuid"
                          error={newMoveObjTemp["unitUuid"] == "" && submitted}
                          onChange={async (event, newValue) => {
                            if (newValue?.uuid) {
                              setNewMoveObjTemp({ ...newMoveObjTemp, "unitUuid": newValue.uuid });
                              setUnit(newValue)
                              setUnitInfo({
                                uuid: newValue.uuid,
                                bedrooms: newValue?.bedrooms || null,
                                baths: newValue?.baths || null
                              })
                              try {
                                let response = await axios.get(`unit-current-occupant/${newValue.uuid}`)
                                setCurrentOccupant(response.data[0])
                              }
                              catch (e) {
                                console.log(e);
                              }
                            }
                            else
                              setCurrentOccupant({})
                          }}
                          renderInput={(params) => <TextField  {...params}
                            label="Unit"
                            size="small"
                            slotProps={{
                              inputLabel: {
                                shrink: true,
                              }
                            }} />}
                        />
                        : null}
                    </FormControl>
                  </Grid>

                </Grid>
          {(currentOccupant?.accountNum && currentOccupant?.customerTypeId == 4) && (
            <Box sx={{ mt: 1.5 }}>
              <Stack direction="row" spacing={1}>
                <Chip label={`Current Occupant - PM: ${currentOccupant.accountNum}`} sx={{ backgroundColor: "success.main", color: "white", fontWeight: 600 }} />
              </Stack>
            </Box>
          )}
          {(currentOccupant?.accountNum && currentOccupant?.customerTypeId != 4) && (
            <Box sx={{ mt: 1.5 }}>
              <Stack direction="row" spacing={1}>
                <Chip label={`Current Occupant - Tenant: ${currentOccupant.accountNum}`} sx={{ backgroundColor: "error.main", color: "white", fontWeight: 600 }} />
              </Stack>
            </Box>
          )}
          {unit?.uuid && (
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Bedrooms"
                  type="number"
                  onChange={onUnitFieldsChange}
                  name="bedrooms"
                  value={unitInfo.bedrooms}
                  disabled={unit?.bedrooms != null}
                  fullWidth
                  size="small"
                  variant="outlined"
                  slotProps={{ inputLabel: { shrink: true } }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Bathrooms"
                  type="number"
                  onChange={onUnitFieldsChange}
                  name="baths"
                  value={unitInfo.baths}
                  disabled={unit?.baths != null}
                  fullWidth
                  size="small"
                  variant="outlined"
                  slotProps={{ inputLabel: { shrink: true } }}
                />
              </Grid>
            </Grid>
          )}
        </Paper>

      {/* Address Info */}
      <Paper elevation={2} sx={sectionSx}>
        <Typography variant="subtitle1" sx={titleSx}>Address Info</Typography>
                {useServiceAddress ?
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={useServiceAddress}
                            onChange={handleUseServiceAddressChange}
                            name="serviceAddressSame"
                          />
                        }
                        label="Use service address as contact and billing info"
                      />
                    </Grid>
                  </Grid>
                  :
                  <>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={useServiceAddress}
                              onChange={handleUseServiceAddressChange}
                              name="serviceAddressSame"
                            />
                          }
                          label="Use service address as contact and billing info"
                        />
                      </Grid>
                    </Grid>
                    <Typography variant="body2" sx={{ mt: 2, mb: 1, fontWeight: 600, color: "text.secondary" }}>Mailing Address</Typography>
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      <Grid item sm={6} xs={12}>
                        <TextField
                          label="Address 1"
                          type="text"
                          onChange={onFieldChange}
                          name="address1"
                          defaultValue={newMoveObjTemp.address1}
                          fullWidth
                          size="small"
                          variant="outlined"
                          slotProps={{
                            inputLabel: {
                              shrink: true,
                            }
                          }}
                          error={newMoveObjTemp["address1"] == "" && submitted}
                          helperText={
                            newMoveObjTemp["address1"] == ""
                              ? "Address required."
                              : "" && submitted
                          }
                        />
                      </Grid>
                      <Grid item sm={6} xs={12}>
                        <TextField
                          label="Address 2"
                          type="text"
                          onChange={onFieldChange}
                          name="address2"
                          defaultValue={newMoveObjTemp.address2}
                          fullWidth
                          size="small"
                          variant="outlined"
                          slotProps={{
                            inputLabel: {
                              shrink: true,
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      <Grid item sm={6} xs={12}>
                        <TextField
                          label="City"
                          type="text"
                          onChange={onFieldChange}
                          name="city"
                          defaultValue={newMoveObjTemp.city}
                          fullWidth
                          size="small"
                          variant="outlined"
                          slotProps={{
                            inputLabel: {
                              shrink: true,
                            }
                          }}
                          error={newMoveObjTemp["city"] == "" && submitted}
                          helperText={
                            newMoveObjTemp["city"] == ""
                              ? "City required."
                              : "" && submitted
                          }
                        />
                      </Grid>
                      <Grid item sm={2} xs={6}>
                        <TextField
                          label="State"
                          type="text"
                          onChange={onFieldChange}
                          name="state"
                          defaultValue={newMoveObjTemp.state}
                          fullWidth
                          size="small"
                          variant="outlined"
                          slotProps={{
                            inputLabel: {
                              shrink: true,
                            }
                          }}
                          error={newMoveObjTemp["state"] == "" && submitted}
                          helperText={
                            newMoveObjTemp["state"] == ""
                              ? "State required."
                              : "" && submitted
                          }
                        />
                      </Grid>
                      <Grid item sm={4} xs={6}>
                        <TextField
                          label="Zip"
                          type="text"
                          onChange={onFieldChange}
                          name="zip"
                          defaultValue={newMoveObjTemp.zip}
                          fullWidth
                          size="small"
                          variant="outlined"
                          slotProps={{
                            inputLabel: {
                              shrink: true,
                            }
                          }}
                          error={newMoveObjTemp["zip"] == "" && submitted}
                          helperText={
                            newMoveObjTemp["zip"] == ""
                              ? "Zip required."
                              : "" && submitted
                          }
                        />
                      </Grid>
                    </Grid>
                    <Box textAlign={'left'}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={state.billingSame}
                            onChange={handleChange}
                            name="billingSame"
                          />
                        }
                        label="Billing Address Same as Mailing"
                      />
                    </Box>
                    <Typography variant="body2" sx={{ mt: 2, mb: 1, fontWeight: 600, color: "text.secondary" }}>Billing Address</Typography>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      <Grid item sm={6} xs={12}>
                        <TextField
                          label="Billing Address 1"
                          type="text"
                          onChange={onFieldChange}
                          name="billingAddress1"
                          disabled={state.billingSame}
                          value={
                            state.billingSame
                              ? newMoveObjTemp.address1
                              : newMoveObjTemp.billingAddress1
                          }
                          fullWidth
                          size="small"
                          variant="outlined"
                          slotProps={{
                            inputLabel: {
                              shrink: true,
                            }
                          }}
                          error={newMoveObjTemp["billingAddress1"] == "" && submitted}
                          helperText={
                            newMoveObjTemp["billingAddress1"] == ""
                              ? "Billing Address required."
                              : "" && submitted
                          }
                        />
                      </Grid>
                      <Grid item sm={6} xs={12}>
                        <TextField
                          label="Billing Address 2"
                          type="text"
                          onChange={onFieldChange}
                          name="billingAddress2"
                          disabled={state.billingSame}
                          value={
                            state.billingSame
                              ? newMoveObjTemp.address2
                              : newMoveObjTemp.billingAddress2
                          }
                          fullWidth
                          size="small"
                          variant="outlined"
                          slotProps={{
                            inputLabel: {
                              shrink: true,
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      <Grid item sm={6} xs={12}>
                        <TextField
                          label="Billing City"
                          type="text"
                          onChange={onFieldChange}
                          name="billingCity"
                          disabled={state.billingSame}
                          value={
                            state.billingSame
                              ? newMoveObjTemp.city
                              : newMoveObjTemp.billingCity
                          }
                          fullWidth
                          size="small"
                          variant="outlined"
                          slotProps={{
                            inputLabel: {
                              shrink: true,
                            }
                          }}
                          error={newMoveObjTemp["billingCity"] == "" && submitted}
                          helperText={
                            newMoveObjTemp["billingCity"] == ""
                              ? "Billing City required."
                              : "" && submitted
                          }
                        />
                      </Grid>
                      <Grid item sm={2} xs={6}>
                        <TextField
                          label="Billing State"
                          type="text"
                          onChange={onFieldChange}
                          name="billingState"
                          disabled={state.billingSame}
                          value={
                            state.billingSame
                              ? newMoveObjTemp.state
                              : newMoveObjTemp.billingState
                          }
                          fullWidth
                          size="small"
                          variant="outlined"
                          slotProps={{
                            inputLabel: {
                              shrink: true,
                            }
                          }}
                          error={newMoveObjTemp["billingState"] == "" && submitted}
                          helperText={
                            newMoveObjTemp["billingState"] == ""
                              ? "Billing State required."
                              : "" && submitted
                          }
                        />
                      </Grid>
                      <Grid item sm={4} xs={6}>
                        <TextField
                          label="Billing Zip"
                          type="text"
                          onChange={onFieldChange}
                          name="billingZip"
                          disabled={state.billingSame}
                          value={
                            state.billingSame
                              ? newMoveObjTemp.zip
                              : newMoveObjTemp.billingZip
                          }
                          fullWidth
                          size="small"
                          variant="outlined"
                          slotProps={{
                            inputLabel: {
                              shrink: true,
                            }
                          }}
                          error={newMoveObjTemp["billingZip"] == "" && submitted}
                          helperText={
                            newMoveObjTemp["billingZip"] == ""
                              ? "Billing Zip required."
                              : "" && submitted
                          }
                        />
                      </Grid>
                    </Grid>
                  </>
                }
      </Paper>

      {/* Move Info */}
      <Paper elevation={2} sx={sectionSx}>
        <Typography variant="subtitle1" sx={titleSx}>Move Info</Typography>
        <Grid container spacing={2}>
          <Grid item sm={6} xs={12}>
            <TextField
              label="Move In Date"
              type="date"
              onChange={onFieldChange}
              name="moveInDate"
              defaultValue={moment(newMoveObjTemp.moveInDate).format("YYYY-MM-DD hh:mm:ss")}
              fullWidth
              size="small"
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
              error={newMoveObjTemp["moveInDate"] == "" && submitted}
              helperText={newMoveObjTemp["moveInDate"] == "" ? "Move In Date required." : "" && submitted}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              label="Read Amt"
              type="number"
              onChange={onFieldChange}
              name="meterRead"
              defaultValue="0"
              fullWidth
              size="small"
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
              helperText="Leave as 0 to auto generate estimate."
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={readTypeChecked == "ACT"}
                  onChange={(e) => { handleReadTypeChange("ACT"); onFieldChange(e); }}
                  name="readAmtType"
                  value="ACT"
                />
              }
              label="ACT Read"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={readTypeChecked == "EST"}
                  onChange={(e) => { handleReadTypeChange("EST"); onFieldChange(e); }}
                  name="readAmtType"
                  value="EST"
                />
              }
              label="EST Read"
            />
          </Grid>
        </Grid>
      </Paper>

      <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => action(newMoveObjTemp, state.billingSame, unitInfo)}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};
